import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { Payout } from 'models/PayoutModel';


const PayoutList: React.FC = () => {
  const width = { sno: 10, type: 10, payee: 20, comment: 20, amount:10, mop:10, date:10, receiveby: 10 }
  const [formId, formName] = [Code.Form.Id.PAYOUT, Code.Form.Name.PAYOUT];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, pageRows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [payoutData, setPayoutData] = useState<Payout[]>([]); 
  const [selectedPayout, setselectedPayout] = useState<Payout | null>(null);
  const [userId, setUserId] = useState<number>(1);
  const [userOptions, setUserOptions] = Hooks.Form.Options();
  const triggers = [pno, pageRows, search, activeId, userId];
  const Privilege = Hooks.Privilege.List(formId);
  const PrivClient = Hooks.Privilege.List(Code.Form.Id.CLIENT);
  const locationId = Utility.Storage.LocationId();
  
  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.Form.Name.USER, Code.Option.Common.ALL, setUserOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, pageRows, Name.Payout.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.Payout.Id, 
        Name.Payout.Number, 
        Name.Common.TypeName, 
        Name.Payout.Amount, 
        Name.Payee.Name, 
        Name.Payout.Comment, 
        Name.Payout.Amount, 
        Name.Common.ModeName, 
        Name.Payout.Date, 
        Name.User.FullName
      ]),
      user_id: userId,
      location_id: locationId,
    });
     
    await API.Data.List<Payout>(url, setPayoutData, setError, setLoading); 
  }, triggers);

  

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.User} value={userId} options={userOptions} onChange={(value) => { setUserId(value);  callListData();  }} />
              <Control.Dropdown title={Title.State} value={activeId} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} value={pageRows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, payoutData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Receipt, width.sno],
                [Title.Type, width.type], 
                [Title.PaidTo, width.payee], 
                [Title.Comment, width.comment], 
                [Title.Amount, width.amount, Code.Align.RIGHT], 
                [Title.MOP, width.mop],
                [Title.Date, width.date], 
                [Title.ReceivedBy, width.receiveby], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(payoutData) && (
              <Control.Grid.Row>
                {payoutData.map((payoutData) => { return (
                <Control.Grid.Data<Payout> key={payoutData.payout_id} itemKey={payoutData.payout_key} data={payoutData} setMenuPosition={setMenuPosition} setSelectedData={setselectedPayout} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={payoutData.payout_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, payoutData.payout_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [payoutData.payout_number, width.sno],
                    [payoutData.type_name, width.type],
                    [payoutData.payee_name, width.payee],
                    [payoutData.payout_comment, width.comment],
                    [Utility.Format.Amount(payoutData.payout_amount), width.amount, Code.Align.RIGHT],
                    [payoutData.mode_name, width.mop],
                    [Utility.Format.DateOnly(payoutData.payout_date), width.date],
                    [Utility.Get.FullName(payoutData,Code.Form.Name.USER), width.receiveby],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={payoutData.payout_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={pageRows} loading={loading} error={error} dataLength={payoutData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedPayout?.payout_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedPayout?.payout_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default PayoutList;